module.exports = __webpack_public_path__ + "img/bolt-white.8718615f.svg";